import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Tooltip from 'vibo-ui/Tooltip';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import googleCalendar from 'services/googleCalendar';
import { useEvent } from 'components/context/EventContext';
import { getDateWithTimezone } from 'services/common/dateHelpers';

import useStyles from './style';

const DateBadge: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { event, isHistory, isEventDj } = useEvent();

  const eventDate = useMemo(
    () =>
      event?.date ? getDateWithTimezone(event.date, event?.timezone, 'ddd, MMM Do YYYY') : 'TBD',
    [event?.date, event?.timezone]
  );

  const disabled = isHistory || !event?.date;

  return (
    <Tooltip
      overlay={disabled ? null : t('addToCalendar')}
      type="primary"
      placement="top"
      fillOverlay
    >
      <div
        onClick={() => !disabled && googleCalendar.create(event)}
        className={classNames('dateBadge', classes.dateBadge, {
          disabled: isHistory || (!isEventDj && !event?.date),
          empty: !event?.date,
        })}
        data-hash={!event?.date ? 'dateinput' : null}
      >
        <Icon icon={IconmoonFont['calendar-24']} />
        {eventDate}
      </div>
    </Tooltip>
  );
};

export default DateBadge;
